import styled from "styled-components";

export const Info = styled.div`
  background-color: rgba(59, 130, 246, 0.1);
  padding: 12px;
  border-radius: 4px;
  display: flex;
  gap: 8px;

  svg {
    color: #3B82F6;
    min-height: 20px;
    min-width: 20px;
  }
`